import React from 'react';
import numeral from 'numeral';

const truncate20 = (input) => input.length > 20 ? `${input.substring(0, 20)}...` : input;
const truncate50 = (input) => input.length > 50 ? `${input.substring(0, 50)}...` : input;


export default function (props) {
    const og = props.data
    let { orderNote,items } = og;
    if (og.orderType !== "pickupAppBulk"){
        return (
            <div>
            <small>LIST BARANG</small>
            { items.map((i,idx) => (
                <div key={idx} className="rounded p-2 mb-1 border shadow--hover">
                    <small><b>{i.quantity}x - {truncate20(i.name)}</b> {truncate50(i.description)}</small><br/>
                    <small>Rp. {numeral(i.value).format("0,0")} <br/></small>
                    <small>{i.length}x{i.width}x{i.height} cm - {i.weight} gram</small>
                </div>
            ))}
            </div>
        )
    } else if (og.orderType === "pickupAppBulk") {
        return (
            <div>
                <small>TOTAL BARANG</small><br/>
                {items[0].quantity} Barang
            </div>
        )
    }

    return (
        <div>
            {orderNote}
        </div>
    )     
}